import { Verify } from 'modules';
import { Route, Switch } from 'react-router-dom';
import React from 'react';

const VerifyPage = () => {
  return (
    <Switch>
      <Route path="/" component={Verify} />
    </Switch>
  );
};

export default VerifyPage;
